import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "PurchaseOrderLines";

export type CreatePOReceiptsRequestObject = {
  Item: string;
  PurchaseOrder: string;
  Release: string;
  ChangeOrder: string;
  StoresLocation: string;
  PoLine: number;
  Employee: string;
  TransactionQuantity: number;
  ReceivedComplete: boolean;
  BillOfLading: string;
  Bin?: string;
  DateCharged: string;
  SupplierReturnFlag: boolean;
  Comments: string;
  Serials?: any;
  LabelPrintCopies: number;
  PrinterName?: any;
  AgentName?: any;
  LabelTemplateName: string;
};

export interface CreatePOReceiptsData {
  Confirmation: {
    RuleConfirmationDetailsList: {
      MessageId: string;
      MessageConfirmationValue: {
        val1: string;
      };
    }[];
  };
  RequestObject: CreatePOReceiptsRequestObject[];
}

export const createPOReceipts = async (data: CreatePOReceiptsData) => {
  return await sendRequest(
    HttpMethods.POST,
    `${CONTROLLER_NAME}/CreatePOReceipts`,
    data
  );
};

type ValidatePOReceiptData = {
  Confirmation: any;
  RequestObject: any;
};

export const validatePOReceiptData = async (data: ValidatePOReceiptData) => {
  return await sendRequest(
    HttpMethods.POST,
    `${CONTROLLER_NAME}/ValidatePOReceiptData`,
    data
  );
};

export interface GetPoReceiptsData {
  poNumber: string;
}

export const getPoReceiptsData = async (params: GetPoReceiptsData) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetPoReceiptsData`,
    {},
    params
  );
};
